import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PendingTemplatesModal.css';

const PendingTemplatesModal = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState(new Set());
  const [sending, setSending] = useState(false);
  const [filter, setFilter] = useState('all'); // 'all', 'pending', 'failed', 'no-template' - Por defecto mostrar TODOS los mensajes
  const [activeTab, setActiveTab] = useState('pending'); // 'pending' o 'sent'
  // Por defecto mostrar el 23 de noviembre (donde hay más plantillas)
  const [selectedDate, setSelectedDate] = useState('2025-11-23'); // Fecha por defecto: 23 de noviembre
  const [sentMessages, setSentMessages] = useState([]);
  const [loadingSent, setLoadingSent] = useState(false);
  const [sentStats, setSentStats] = useState(null);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      console.log('🔄 Modal abierto, activeTab:', activeTab, 'filter:', filter);
      // Asegurar que el filtro sea 'all' cuando se abre el modal
      if (filter !== 'all') {
        console.log('⚠️ Filtro no es "all", cambiando a "all" para mostrar todos los mensajes');
        setFilter('all');
      }
      if (activeTab === 'pending') {
        console.log('📤 Cargando mensajes pendientes con filtro:', filter);
        loadPendingMessages();
      } else {
        console.log('✅ Cargando mensajes enviados para fecha:', selectedDate);
        loadSentMessages();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, activeTab, selectedDate]);

  // Cargar mensajes cuando cambia el filtro
  useEffect(() => {
    if (isOpen && activeTab === 'pending') {
      console.log('🔄 Filtro cambiado a:', filter);
      loadPendingMessages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const loadPendingMessages = async () => {
    setLoading(true);
    setMessages([]); // Limpiar mensajes anteriores
    try {
      console.log('🔍 Cargando mensajes pendientes con filtro:', filter);
      console.log('🔑 Token de autenticación:', axios.defaults.headers.common['Authorization'] ? 'Presente' : 'FALTANTE');
      
      const response = await axios.get('/api/messages/pending-templates', {
        params: { filter },
        headers: {
          'Authorization': axios.defaults.headers.common['Authorization'] || `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      console.log('✅ Respuesta recibida:', response.data);
      console.log('📊 Success:', response.data.success);
      console.log('📊 Total mensajes:', response.data.messages?.length || 0);
      
      if (response.data.messages && response.data.messages.length > 0) {
        console.log('📊 Primeros 3 mensajes:', response.data.messages.slice(0, 3));
      }
      
      if (response.data.success && response.data.messages) {
        setMessages(response.data.messages);
        console.log('✅ Mensajes actualizados en el estado:', response.data.messages.length);
      } else {
        console.warn('⚠️ Respuesta sin success o sin mensajes');
        console.warn('⚠️ Datos completos:', JSON.stringify(response.data, null, 2));
        setMessages([]);
      }
    } catch (error) {
      console.error('❌ Error cargando mensajes pendientes:', error);
      console.error('❌ Status:', error.response?.status);
      console.error('❌ Status Text:', error.response?.statusText);
      console.error('❌ Detalles del error:', error.response?.data);
      console.error('❌ Error completo:', error);
      setMessages([]);
      
      if (error.response?.status === 401) {
        alert('Error de autenticación. Por favor, inicia sesión nuevamente.');
      } else {
        alert('Error al cargar mensajes pendientes: ' + (error.response?.data?.error || error.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const loadSentMessages = async () => {
    setLoadingSent(true);
    setSentMessages([]); // Limpiar mensajes anteriores
    setSentStats(null);
    try {
      console.log('🔍 Cargando plantillas enviadas para:', selectedDate);
      console.log('🔑 Token de autenticación:', axios.defaults.headers.common['Authorization'] ? 'Presente' : 'FALTANTE');
      
      const response = await axios.get('/api/messages/templates-by-date', {
        params: { date: selectedDate },
        headers: {
          'Authorization': axios.defaults.headers.common['Authorization'] || `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      console.log('✅ Respuesta recibida:', response.data);
      console.log('📊 Success:', response.data.success);
      console.log('📊 Total mensajes en respuesta:', response.data.messages?.length || 0);
      console.log('📊 Estadísticas:', response.data.stats);
      
      if (response.data.success && response.data.messages) {
        if (response.data.messages.length > 0) {
          console.log('📋 Primeros 3 mensajes:', response.data.messages.slice(0, 3));
        }
        setSentMessages(response.data.messages);
        setSentStats(response.data.stats || null);
        console.log('✅ Mensajes enviados actualizados en el estado:', response.data.messages.length);
      } else {
        console.warn('⚠️ Respuesta sin success o sin mensajes');
        console.warn('⚠️ Datos completos:', JSON.stringify(response.data, null, 2));
        setSentMessages([]);
        setSentStats(null);
      }
    } catch (error) {
      console.error('❌ Error cargando plantillas enviadas:', error);
      console.error('❌ Status:', error.response?.status);
      console.error('❌ Status Text:', error.response?.statusText);
      console.error('❌ Detalles del error:', error.response?.data);
      console.error('❌ Error completo:', error);
      setSentMessages([]);
      setSentStats(null);
      
      if (error.response?.status === 401) {
        alert('Error de autenticación. Por favor, inicia sesión nuevamente.');
      } else {
        alert('Error al cargar plantillas enviadas: ' + (error.response?.data?.error || error.message));
      }
    } finally {
      setLoadingSent(false);
    }
  };

  const toggleSelectMessage = (messageId) => {
    // Permitir seleccionar cualquier mensaje (con o sin plantilla) para poder reenviar
    const newSelected = new Set(selectedMessages);
    if (newSelected.has(messageId)) {
      newSelected.delete(messageId);
    } else {
      newSelected.add(messageId);
    }
    setSelectedMessages(newSelected);
  };

  const toggleSelectAll = () => {
    // Seleccionar todos los mensajes (con o sin plantilla)
    if (selectedMessages.size === messages.length && messages.length > 0) {
      setSelectedMessages(new Set());
    } else {
      setSelectedMessages(new Set(messages.map(m => m._id)));
    }
  };

  const resendTemplates = async () => {
    if (selectedMessages.size === 0) {
      alert('Por favor selecciona al menos un mensaje');
      return;
    }

    const selectedMessagesList = Array.from(selectedMessages);
    const selectedMessagesData = messages.filter(m => selectedMessagesList.includes(m._id));
    const conPlantilla = selectedMessagesData.filter(m => m.hasTemplate).length;
    const sinPlantilla = selectedMessagesData.filter(m => !m.hasTemplate).length;

    let confirmMessage = `¿Estás seguro de que deseas reenviar ${selectedMessages.size} plantilla(s)?\n\n`;
    if (conPlantilla > 0 && sinPlantilla > 0) {
      confirmMessage += `- ${sinPlantilla} sin plantilla (se enviará por primera vez)\n`;
      confirmMessage += `- ${conPlantilla} con plantilla (se reenviará)`;
    } else if (conPlantilla > 0) {
      confirmMessage += `Estos mensajes ya tienen plantilla enviada. Se reenviará la plantilla.`;
    }

    if (!window.confirm(confirmMessage)) {
      return;
    }

    setSending(true);
    try {
      console.log('📤 Reenviando plantillas para:', selectedMessagesList);
      const response = await axios.post('/api/messages/resend-templates', {
        messageIds: selectedMessagesList
      }, {
        headers: {
          'Authorization': axios.defaults.headers.common['Authorization'] || `Bearer ${localStorage.getItem('token')}`
        }
      });

      console.log('✅ Respuesta del reenvío:', response.data);

      if (response.data.success) {
        alert(`✅ ${response.data.sent} plantilla(s) enviada(s) exitosamente\n⚠️ ${response.data.failed} fallaron`);
        setSelectedMessages(new Set());
        // Recargar mensajes después de un breve delay para que el servidor procese
        setTimeout(() => {
          loadPendingMessages();
        }, 1000);
      } else {
        alert('Error al reenviar plantillas: ' + (response.data.error || 'Error desconocido'));
      }
    } catch (error) {
      console.error('❌ Error reenviando plantillas:', error);
      console.error('   Status:', error.response?.status);
      console.error('   Data:', error.response?.data);
      alert('Error al reenviar plantillas: ' + (error.response?.data?.error || error.message));
    } finally {
      setSending(false);
    }
  };

  const deleteAllMessages = async () => {
    if (messages.length === 0) {
      alert('No hay mensajes para eliminar');
      return;
    }

    const confirmMessage = `¿Estás seguro de que deseas eliminar TODOS los ${messages.length} mensajes pendientes?\n\nEsta acción no se puede deshacer.`;
    
    if (!window.confirm(confirmMessage)) {
      return;
    }

    setDeleting(true);
    try {
      console.log('🗑️  Eliminando todos los mensajes pendientes...');
      const response = await axios.delete('/api/messages/pending-templates', {
        headers: {
          'Authorization': axios.defaults.headers.common['Authorization'] || `Bearer ${localStorage.getItem('token')}`
        }
      });

      console.log('✅ Respuesta de eliminación:', response.data);

      if (response.data.success) {
        alert(`✅ ${response.data.deletedCount} mensaje(s) eliminado(s) exitosamente`);
        setSelectedMessages(new Set());
        // Recargar mensajes después de un breve delay
        setTimeout(() => {
          loadPendingMessages();
        }, 500);
      } else {
        alert('Error al eliminar mensajes: ' + (response.data.error || 'Error desconocido'));
      }
    } catch (error) {
      console.error('❌ Error eliminando mensajes:', error);
      console.error('   Status:', error.response?.status);
      console.error('   Data:', error.response?.data);
      alert('Error al eliminar mensajes: ' + (error.response?.data?.error || error.message));
    } finally {
      setDeleting(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = new Date(date);
    return d.toLocaleString('es-DO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (message) => {
    if (message.hasTemplate) {
      return <span className="status-badge success">✅ Enviada</span>;
    }
    if (message.status === 'failed') {
      return <span className="status-badge error">❌ Error</span>;
    }
    if (message.status === 'pending') {
      return <span className="status-badge pending">⏳ Pendiente</span>;
    }
    if (message.status === 'delivered') {
      return <span className="status-badge success">✓ Entregada</span>;
    }
    if (message.status === 'read') {
      return <span className="status-badge success">✓✓ Leída</span>;
    }
    if (message.status === 'sent') {
      return <span className="status-badge success">✓ Enviada</span>;
    }
    return <span className="status-badge no-template">⚠️ Sin plantilla</span>;
  };

  if (!isOpen) return null;

  return (
    <div className="pending-templates-modal-overlay" onClick={onClose}>
      <div className="pending-templates-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pending-templates-header">
          <h2>📤 Plantillas de Mensajes</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        {/* Tabs */}
        <div className="templates-tabs">
          <button
            className={`tab-button ${activeTab === 'pending' ? 'active' : ''}`}
            onClick={() => setActiveTab('pending')}
          >
            ⏳ Pendientes
          </button>
          <button
            className={`tab-button ${activeTab === 'sent' ? 'active' : ''}`}
            onClick={() => setActiveTab('sent')}
          >
            ✅ Enviadas
          </button>
        </div>

        <div className="pending-templates-content">
          {activeTab === 'pending' ? (
            <>
              {/* Filtros para mensajes pendientes */}
              <div className="pending-templates-filters">
                <button
                  className={`filter-button ${filter === 'all' ? 'active' : ''}`}
                  onClick={() => setFilter('all')}
                >
                  Todos
                </button>
                <button
                  className={`filter-button ${filter === 'no-template' ? 'active' : ''}`}
                  onClick={() => setFilter('no-template')}
                >
                  Sin Plantilla
                </button>
                <button
                  className={`filter-button ${filter === 'pending' ? 'active' : ''}`}
                  onClick={() => setFilter('pending')}
                >
                  Pendientes
                </button>
                <button
                  className={`filter-button ${filter === 'failed' ? 'active' : ''}`}
                  onClick={() => setFilter('failed')}
                >
                  Con Error
                </button>
              </div>

              <div className="pending-templates-actions">
                <button
                  className="select-all-button"
                  onClick={toggleSelectAll}
                  disabled={messages.length === 0}
                >
                  {selectedMessages.size === messages.length && messages.length > 0
                    ? 'Deseleccionar Todos' 
                    : `Seleccionar Todos (${messages.length})`}
                </button>
                <button
                  className="resend-button"
                  onClick={resendTemplates}
                  disabled={selectedMessages.size === 0 || sending || messages.length === 0}
                >
                  {sending ? '⏳ Enviando...' : `📤 Reenviar Plantilla (${selectedMessages.size})`}
                </button>
                {/* Botón para eliminar todos los mensajes pendientes */}
                <button
                  className="delete-all-button"
                  onClick={deleteAllMessages}
                  disabled={messages.length === 0 || deleting}
                  title="Eliminar todos los mensajes pendientes"
                  style={{ display: 'block', visibility: 'visible' }}
                >
                  {deleting ? '⏳ Eliminando...' : `🗑️ Borrar Plantillas (${messages.length})`}
                </button>
              </div>

              {loading ? (
                <div className="loading">Cargando mensajes de Mikrowisp...</div>
              ) : messages.length === 0 ? (
                <div className="empty-state">
                  <p>No hay mensajes de Mikrowisp para mostrar</p>
                </div>
              ) : (
                <table className="pending-templates-table">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>
                        <input
                          type="checkbox"
                          checked={selectedMessages.size === messages.length && messages.length > 0}
                          onChange={toggleSelectAll}
                        />
                      </th>
                      <th>Teléfono</th>
                      <th>Cliente</th>
                      <th>ID Mikrowisp</th>
                      <th>Mensaje</th>
                      <th>Tipo Esperado</th>
                      <th>Estado</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    {messages.map((message) => (
                      <tr 
                        key={message._id} 
                        className={`${selectedMessages.has(message._id) ? 'selected' : ''} ${!message.hasTemplate ? 'no-template-row' : 'has-template-row'}`}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedMessages.has(message._id)}
                            onChange={() => toggleSelectMessage(message._id)}
                          />
                        </td>
                        <td>{message.phoneNumber}</td>
                        <td>{message.contactName || 'N/A'}</td>
                        <td>{message.mikrowispId || 'N/A'}</td>
                        <td className="message-text">
                          {message.content?.text || message.message || 'N/A'}
                        </td>
                        <td>
                          {message.expectedTemplate === 'nuevo_cliente' && '🆕 Nuevo Cliente'}
                          {message.expectedTemplate === 'recordatorio_de_pago1' && '💰 Recordatorio'}
                          {message.expectedTemplate === 'payment_confirmation_1' && '✅ Confirmación'}
                        </td>
                        <td>{getStatusBadge(message)}</td>
                        <td>{formatDate(message.timestamp || message.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </>
          ) : (
            <>
              {/* Selector de fecha para mensajes enviados */}
              <div className="date-selector-container">
                <label htmlFor="date-selector">📅 Seleccionar fecha:</label>
                <input
                  id="date-selector"
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="date-input"
                />
                {sentStats && (
                  <div className="sent-stats">
                    <span>📊 Total: {sentStats.total}</span>
                    {sentStats.byTemplate.map(stat => (
                      <span key={stat.templateName}>
                        {stat.templateName}: {stat.count}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {loadingSent ? (
                <div className="loading">Cargando plantillas enviadas para {selectedDate}...</div>
              ) : sentMessages.length === 0 ? (
                <div className="empty-state">
                  <p>No hay plantillas enviadas para la fecha {selectedDate}</p>
                  <p style={{ fontSize: '12px', color: '#999', marginTop: '10px' }}>
                    Total en estado: {sentMessages.length} | Prueba seleccionando otra fecha o verifica que haya plantillas en esa fecha.
                  </p>
                </div>
              ) : (
                <table className="pending-templates-table">
                  <thead>
                    <tr>
                      <th>Teléfono</th>
                      <th>Cliente</th>
                      <th>ID Mikrowisp</th>
                      <th>Plantilla</th>
                      <th>Mensaje</th>
                      <th>Estado</th>
                      <th>Fecha/Hora</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sentMessages.map((message) => (
                      <tr key={message._id}>
                        <td>{message.phoneNumber}</td>
                        <td>{message.contactName || 'N/A'}</td>
                        <td>{message.mikrowispId || 'N/A'}</td>
                        <td>
                          <span className="template-name-badge">
                            {message.templateName === 'nuevo_cliente' && '🆕 nuevo_cliente'}
                            {message.templateName === 'recordatorio_de_pago1' && '💰 recordatorio_de_pago1'}
                            {message.templateName === 'payment_confirmation_1' && '✅ payment_confirmation_1'}
                            {!['nuevo_cliente', 'recordatorio_de_pago1', 'payment_confirmation_1'].includes(message.templateName) && message.templateName}
                          </span>
                        </td>
                        <td className="message-text">
                          {message.message || 'N/A'}
                        </td>
                        <td>{getStatusBadge(message)}</td>
                        <td>{formatDate(message.timestamp)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>

        <div className="pending-templates-footer">
          {activeTab === 'pending' ? (
            <>
              <p>
                <strong>Total: {messages.length} mensaje(s) de Mikrowisp</strong> | 
                <span style={{ color: '#856404', fontWeight: 'bold', marginLeft: '10px' }}>
                  ⚠️ Sin plantilla: {messages.filter(m => !m.hasTemplate).length}
                </span> | 
                <span style={{ color: '#155724', fontWeight: 'bold', marginLeft: '10px' }}>
                  ✅ Con plantilla: {messages.filter(m => m.hasTemplate).length}
                </span>
              </p>
              <p>Seleccionados para reenviar: {selectedMessages.size}</p>
            </>
          ) : (
            <>
              <p><strong>Total: {sentMessages.length} plantilla(s) enviada(s)</strong></p>
              {sentStats && (
                <p>
                  Enviadas: {sentStats.byStatus.sent} | 
                  Entregadas: {sentStats.byStatus.delivered} | 
                  Leídas: {sentStats.byStatus.read} | 
                  Fallidas: {sentStats.byStatus.failed}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingTemplatesModal;
